module.exports = __webpack_public_path__ + "static/img/zhong8.653206b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong8.png
// module id = 1Hms
// module chunks = 16